// removed by extract-text-webpack-plugin
module.exports = {"form":"SkipLink__form___3T0iu","buttonAsLink":"SkipLink__buttonAsLink___1Ou7N","primary":"SkipLink__primary___1TOSi","pypl-btn--small":"SkipLink__pypl-btn--small___1lADM","pypl-btn--outline-white":"SkipLink__pypl-btn--outline-white___4lcqB","pypl-btn--outline-blue":"SkipLink__pypl-btn--outline-blue___Bq50Y","pypl-btn--gray":"SkipLink__pypl-btn--gray___157RG","pypl-btn--white":"SkipLink__pypl-btn--white___2bS5X","primaryLink":"SkipLink__primaryLink___2qjM7","secondaryLink":"SkipLink__secondaryLink___2qLC3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/types/skipLinks/SkipLink.less
 ** module id = 777
 ** module chunks = 0
 **/